/** Two letters, from two words where there are two — "Ta' Rikardu" reads as TR, not TA. */
export const venueMonogram = (name: string): string => {
  const words = name.split(/\s+/).filter(Boolean)

  return (words.length > 1 ? `${words[0][0]}${words[1][0]}` : name.slice(0, 2)).toUpperCase()
}
